/* eslint-disable no-unused-vars */

import {
  getPriceLevel1,
  getPriceLevel3,
  getPriceBox
} from '@/helper/functions';

const today = new Date();

export default class ShopItem {
  constructor() {
    this.data = null;
  }

  maxQty(store) {
    var b2b = false;
    if (store.getters.isB2b) {
      b2b = true;
    }
    var max = 9999;
    if (this.data !== null) {
      if (this.data.type === 'level_1') {
        this.data.products.forEach(product => {
          if (product.replaced) {
            if (
              product.replaceData.stock_quantity !== null &&
              Math.floor(product.replaceData.stock_quantity / product.quantity) < max
            ) {
              if (!b2b || product.replaceData.custom_delivery_qty.allow_backorders !== 'ja') {
                max = Math.floor(product.replaceData.stock_quantity / product.quantity);
              }
            }
          } else {
            if (
              product.stock_quantity !== null &&
              Math.floor(product.stock_quantity / product.quantity) < max
            ) {
              if (!b2b || product.custom_delivery_qty.allow_backorders !== 'ja') {
                max = Math.floor(product.stock_quantity / product.quantity);
              }
            }
          }
        });
      } else if (this.data.type === 'level_3') {
        this.data.products.forEach(product => {
          if (
            product.stock_quantity !== null &&
            Math.floor(
              product.stock_quantity / this.data.qtyCache[product.id]
            ) < max
          ) {
            if (!b2b || product.custom_delivery_qty.allow_backorders !== 'ja') {
              max = Math.floor(
                product.stock_quantity / this.data.qtyCache[product.id]
              );
            }
          }
        });
      }
    }

    return max;
  }

  maxBoxQtyLevel3Product (store, product) {
    var max = 0;

    if (product !== undefined) {
      max = product.stock_quantity;
      if (
        product.stock_quantity !== null &&
        Math.floor(
          product.stock_quantity / this.data.qtyCache[product.id]
        ) < max
      ) {
        if (!store.getters.isB2b || product.custom_delivery_qty.allow_backorders !== 'ja') {
          max = Math.floor(
            product.stock_quantity / this.data.qtyCache[product.id]
          );
        }
      }
    }

    return max;
  }

  rawPrice(userGroupId, includeBox, net) {
    if (this.data === null) {
      return 0;
    }
    var sum = 0;

    if (this.data.type === 'level_3') {
      this.data.products.forEach(product => {
        sum += getPriceLevel3(product, userGroupId, net);
      });
      return sum;
    }

    return getPriceLevel1(this.data, userGroupId, includeBox, net);
  }

  rawBoxPrice(userGroupId, net) {
    if (this.data === null) {
      return 0;
    }

    return getPriceBox(this.data, userGroupId, net);
  }

  qtyProducts() {
    var qty = 0;
    if (this.data !== null) {
      if (this.data.type === 'level_1') {
        this.data.products.forEach(product => {
          if (product.type === 'product') {
            qty += parseInt(product.quantity);
          }
        });
      } else if (this.data.type === 'level_3') {
        qty = this.data.products.length;
      }
    }

    return qty;
  }

  includedProducts() {
    if (this.data === null) {
      return [];
    }
    if (this.data.type === 'level_3') {
      return this.data.products;
    }
    var ret = [];
    this.data.products.forEach(product => {
      if (product.type === 'product') {
        ret.push(product);
      }
    });

    return ret;
  }

  getDeliveryTime(store) {
    // Add here time for delivery
    var addForChristmas = 0;
    if ([62, 2569, 2571, 2548].includes(parseInt(store.getters.getUserGroupId))) {
      addForChristmas = 0;
    }
    if (this.data === null) {
      return 3 + addForChristmas;
    }
    var minTime = 0;
    var maxTime = 0;
    var alreadyAdded = false;
    if (store.getters.getDelTimeSettings !== undefined) {
      store.getters.getDelTimeSettings.forEach(entry => {
        if (entry.min <= store.getters.getSelectedQty && !alreadyAdded) {
          minTime += entry.value_lvl3;
          maxTime += entry.value_lvl3;
          alreadyAdded = true;
        }
      });
    }

    var addThreshold = 0;
    var minTimeProduct = 0;
    var maxTimeProduct = 0;
    var addThresholdFuture = 0;
    var useFutureDate = false;
    store.commit('setFutureDate', {
      use: false,
      val: ''
    });

    if (this.data.type === 'level_1') {
      this.data.products.forEach(product => {
        if (product.replaced) {
          const pQty = product.quantity;
          product = product.replaceData;
          product.quantity = pQty;
        }
        const productDate = new Date(product.release_date);
        if (
          productDate > today &&
          Math.floor((productDate - today) / (1000 * 60 * 60 * 24)) / 1.4 >
            addThresholdFuture
        ) {
          addThresholdFuture = Math.floor(
            (productDate - today) / (1000 * 60 * 60 * 24) / 1.4
          );
          useFutureDate = true;
          store.commit('setFutureDate', {
            use: true,
            val: productDate.toLocaleDateString('de-DE')
          });
        } else {
          if (
            product.stock_quantity +
              product.custom_delivery_qty.threshold_1 <
              store.getters.getSelectedQty * product.quantity &&
            product.custom_delivery_qty.threshold_1_time > addThreshold
          ) {
            addThreshold = product.custom_delivery_qty.threshold_1_time;
          } else if (
            product.stock_quantity <
            store.getters.getSelectedQty * product.quantity
          ) {
            if (product.delivery_time !== null) {
              const numbers = product.delivery_time.split('-');
              if (
                numbers.length === 1 &&
                parseInt(numbers[0]) > minTimeProduct &&
                parseInt(numbers[0]) > maxTimeProduct
              ) {
                minTimeProduct = parseInt(numbers[0]);
                maxTimeProduct = parseInt(numbers[0]);
              } else if (
                numbers.length === 3 &&
                parseInt(numbers[1]) > minTimeProduct &&
                parseInt(numbers[1]) > maxTimeProduct
              ) {
                minTimeProduct = parseInt(numbers[1]);
                maxTimeProduct = parseInt(numbers[1]);
              } else if (
                numbers.length === 4 &&
                parseInt(numbers[1]) > minTimeProduct &&
                parseInt(numbers[2]) > maxTimeProduct
              ) {
                minTimeProduct = parseInt(numbers[1]);
                maxTimeProduct = parseInt(numbers[2]);
              }
            }
          }
        }

        if (product.fut_days > 0) {
          minTimeProduct = product.fut_days;
          maxTimeProduct = product.fut_days;
        }
      });
    } else if (this.data.type === 'level_3') {
      this.data.products.forEach(product => {
        const productDate = new Date(product.release_date);
        if (
          productDate > today &&
          Math.floor((productDate - today) / (1000 * 60 * 60 * 24)) / 1.4 >
            addThresholdFuture
        ) {
          addThresholdFuture = Math.floor(
            (productDate - today) / (1000 * 60 * 60 * 24) / 1.4
          );
          useFutureDate = true;
          store.commit('setFutureDate', {
            use: true,
            val: productDate.toLocaleDateString('de-DE')
          });
        } else {
          if (
            product.stock_quantity +
              product.custom_delivery_qty.threshold_1 <
              store.getters.getSelectedQty * this.data.qtyCache[product.id] &&
            product.custom_delivery_qty.threshold_1_time > addThreshold
          ) {
            addThreshold = product.custom_delivery_qty.threshold_1_time;
          } else if (
            product.stock_quantity <
            store.getters.getSelectedQty * this.data.qtyCache[product.id]
          ) {
            if (product.delivery_time !== null) {
              const numbers = product.delivery_time.split('-');
              if (
                numbers.length === 1 &&
                parseInt(numbers[0]) > minTimeProduct &&
                parseInt(numbers[0]) > maxTimeProduct
              ) {
                minTimeProduct = parseInt(numbers[0]);
                maxTimeProduct = parseInt(numbers[0]);
              } else if (
                numbers.length === 3 &&
                parseInt(numbers[1]) > minTimeProduct &&
                parseInt(numbers[1]) > maxTimeProduct
              ) {
                minTimeProduct = parseInt(numbers[1]);
                maxTimeProduct = parseInt(numbers[1]);
              } else if (
                numbers.length === 4 &&
                parseInt(numbers[1]) > minTimeProduct &&
                parseInt(numbers[2]) > maxTimeProduct
              ) {
                minTimeProduct = parseInt(numbers[1]);
                maxTimeProduct = parseInt(numbers[2]);
              }
            }
          }
        }

        if (product.fut_days > 0) {
          minTimeProduct = product.fut_days;
          maxTimeProduct = product.fut_days;
        }
      });
    }

    if (addThreshold > minTimeProduct && addThreshold > maxTimeProduct) {
      minTime += addThreshold;
      maxTime += addThreshold;
    } else {
      minTime += minTimeProduct;
      maxTime += maxTimeProduct;
    }

    if (addThresholdFuture < minTime || addThresholdFuture < maxTime) {
      useFutureDate = false;
      store.commit('setFutureDate', {
        use: false,
        val: ''
      });
    }

    if (useFutureDate) {
      return ((minTime - 1 + maxTime - 1) / 2) + addForChristmas;
    }
    return ((minTime + maxTime) / 2) + addForChristmas;
  }
}
